'use client'
import React from 'react'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { useComparisons } from '../hooks/dataloader/use-comparisons'
import CompareComponent from './compare-button'

type Props = {
  productId: string
  displayName?: string | null
  categoryName: string
  text?: string
  listForm?: boolean
  className?: string
  withBorder?: boolean
  noText?: boolean
  productInformationCompareIcon?: boolean
}

const ProductCompare = ({
  productId,
  displayName,
  categoryName,
  text = 'Compare',
  listForm = false,
  className,
  withBorder = false,
  noText = false,
  productInformationCompareIcon = false,
}: Props) => {
  const { translate } = useTranslations()
  const { isProxied } = useSiteContext()

  const { updateComparisons, comparisonsData } = useComparisons()

  const updateCompareList = async () => {
    if (!comparisonsData) return

    await updateComparisons(comparisonsData, productId, categoryName, displayName || '')
    if (isProxied) {
      const event = new CustomEvent('update-legacy-compare-menu')
      document.dispatchEvent(event)
    }
  }

  const itemExist = comparisonsData?.some(item =>
    item?.items?.some(i => i?.productErpIdentifier === productId)
  )

  return (
    <CompareComponent
      listForm={listForm}
      itemExist={itemExist}
      updateCompareList={e => {
        e.preventDefault()
        updateCompareList()
      }}
      noText={noText}
      withBorder={withBorder}
      className={className}
      productInformationCompareIcon={productInformationCompareIcon}
      buttonText={translate(text)}
      tooltipText={itemExist ? translate('Compare_IsCompared') : translate('CompareProduct')}
    />
  )
}

export const CompareButton = ({
  productId,
  displayName,
  categoryName,
  text = 'Compare',
  listForm = false,
  className,
  withBorder = false,
  noText = false,
  productInformationCompareIcon = false,
}: Props) => {
  const { translate } = useTranslations()
  const { isProxied } = useSiteContext()

  const { updateComparisons, comparisonsData } = useComparisons()

  const updateCompareList = async () => {
    if (!comparisonsData) return

    await updateComparisons(comparisonsData, productId, categoryName, displayName || '')
    if (isProxied) {
      const event = new CustomEvent('update-legacy-compare-menu')
      document.dispatchEvent(event)
    }
  }

  const itemExist = comparisonsData?.some(item =>
    item?.items?.some(i => i?.productErpIdentifier === productId)
  )

  return (
    <CompareComponent
      listForm={listForm}
      itemExist={itemExist}
      updateCompareList={(e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        updateCompareList()
      }}
      noText={noText}
      withBorder={withBorder}
      className={className}
      productInformationCompareIcon={productInformationCompareIcon}
      buttonText={translate(text)}
      tooltipText={itemExist ? translate('Compare_IsCompared') : translate('CompareProduct')}
    />
  )
}

export default ProductCompare
